/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_ClearInputs */

const en_date_clear = /** @type {(inputs: Date_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear date`)
};

const de_date_clear = /** @type {(inputs: Date_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum entfernen`)
};

/**
* | output |
* | --- |
* | "Clear date" |
*
* @param {Date_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const date_clear = /** @type {((inputs?: Date_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_date_clear(inputs)
	return en_date_clear(inputs)
});